import type { ProcessingStatus } from "@cdt/shared";

import {
  STATUS_LIST,
  statusLabel,
  statusVariant,
} from "@/components/events/StatusBadge";
import { Badge } from "@/components/ui/badge";

interface StatusCheckboxGroupProps {
  value: ProcessingStatus[] | undefined;
  onChange: (value: ProcessingStatus[] | undefined) => void;
}

export function StatusCheckboxGroup({
  value,
  onChange,
}: StatusCheckboxGroupProps) {
  const selected = new Set<ProcessingStatus>(value ?? []);

  function toggle(status: ProcessingStatus) {
    const next = new Set(selected);
    if (next.has(status)) next.delete(status);
    else next.add(status);
    onChange(next.size > 0 ? Array.from(next) : undefined);
  }

  return (
    <fieldset className="space-y-1.5">
      <legend className="mb-1 text-xs font-medium text-muted-foreground">
        Stato
      </legend>
      <div className="flex flex-wrap gap-2">
        {STATUS_LIST.map((status) => {
          const checked = selected.has(status);
          return (
            <label
              key={status}
              className={`inline-flex cursor-pointer items-center gap-2 rounded-md border px-2.5 py-1 text-sm transition-colors ${
                checked
                  ? "border-primary bg-primary/5"
                  : "border-input hover:bg-muted"
              }`}
            >
              <input
                type="checkbox"
                className="h-3.5 w-3.5 accent-primary"
                checked={checked}
                onChange={() => toggle(status)}
              />
              <Badge variant={statusVariant(status)} className="pointer-events-none">
                {statusLabel(status)}
              </Badge>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
